import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import { SubscriptionCreatorSliceState } from './subscription-creator.state';
import {
	fetchAvailableProjectsSuccess,
	fetchDatablockColumnsSuccess,
	fetchSourceColumnsSuccess,
	fetchSubscriptionDataBlocksSuccess,
	saveNewSubscriptionSuccess,
} from './subscription.actions';

export const subscriptionCreatorReducer =
	createReducer<SubscriptionCreatorSliceState>(
		new SubscriptionCreatorSliceState(),
		on(fetchSubscriptionDataBlocksSuccess, (state, action) =>
			state.setShareableDatablocks(action.datablocks)
		),
		on(fetchDatablockColumnsSuccess, (state, action) =>
			state.updateDatablockListWithColumns(
				action.datablockId,
				action.datablockColumns
			)
		),
		on(fetchSourceColumnsSuccess, (state, action) =>
			state.setAvailableColumns(action.columns)
		),
		on(fetchAvailableProjectsSuccess, (state, action) =>
			state.setAvailableProjects(action.projects)
		),
		on(saveNewSubscriptionSuccess, (state) => state.clear()),
		on(goToProjects, setProject, (state) => state.clear())
	);
